export const MAIN_COLOR = "#9E007E";
